<template>
  <div>
    <common-list
      ref="list"
      url="TerminalRule/GetList"
      @currentrow="handlerCurrentRow"
    >
      <template v-slot:filter="{ filter }">
        <el-form-item label="终端编号" prop="TerminalNo">
          <el-input
            v-model.trim="filter.TerminalNo"
            placeholder="终端编号"
            clearable
          ></el-input>
        </el-form-item>
      </template>
      <template v-slot:option>
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="add"
          v-if="auth('TerminalRuleAdd')"
          >添加</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-edit"
          @click="edit"
          v-if="auth('TerminalRuleEdit')"
          >编辑</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="deleteItem"
          v-if="
            auth('TerminalRuleDelete') &&
            currentrow &&
            currentrow.IsDefault != '1'
          "
          >删除</el-button
        >
        <el-button
          type="success"
          @click="setDef"
          v-if="
            auth('SetTerminalRuleDef') &&
            currentrow &&
            currentrow.IsDefault != '1'
          "
          >设为默认</el-button
        >
      </template>
      <template v-slot:body>
        <el-table-column
          label="终端编号"
          prop="TerminalNo"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="终端名称"
          prop="TerminalName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="终端类型"
          prop="DicName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="终端IP"
          prop="TerminalIp"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="终端MAC"
          prop="TerminalMac"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="是否默认">
          <template v-slot="{ row }">
            <span>{{ row.IsDefault == "1" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
      </template>
    </common-list>
    <add-edit
      ref="addedit"
      @success="getData"
      :item="aeitem"
      title="终端规则"
      getUrl="TerminalRule/GetTerminalRuleByID"
      addUrl="TerminalRule/Add"
      editUrl="TerminalRule/Edit"
      width="600px"
      labelWidth="150px"
    >
      <template v-slot="{ form }">
        <el-form-item
          label="终端编号"
          prop="TerminalNo"
          :rules="[$g.validRequired, $g.validLen(16)]"
        >
          <el-input
            v-model.trim="form.TerminalNo"
            placeholder="终端编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="终端名称"
          prop="TerminalName"
          :rules="$g.validLen(32)"
        >
          <el-input
            v-model.trim="form.TerminalName"
            placeholder="终端名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="终端类型"
          prop="TerminalType"
          :rules="$g.validRequired"
        >
          <DataDic v-model="form.TerminalType" type="TerminalType"></DataDic>
        </el-form-item>
        <el-form-item
          label="终端IP"
          prop="TerminalIp"
          :rules="[$g.validRequired, $g.validIP]"
        >
          <el-input
            v-model.trim="form.TerminalIp"
            placeholder="终端IP"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="终端MAC" prop="TerminalMac" :rules="$g.validMAC">
          <el-input
            v-model.trim="form.TerminalMac"
            placeholder="终端MAC"
            clearable
          ></el-input>
        </el-form-item>
      </template>
    </add-edit>
  </div>
</template>

<script>
export default {
  data() {
    return {
      aeitem: {},
    };
  },
  mounted() {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      this.$refs.addedit.type = "add";
      this.aeitem = {};
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$refs.addedit.type = "edit";
      this.aeitem = { TerminalId: this.currentrow.TerminalId };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除规则名称为【${this.currentrow.TerminalName}】的规则, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("TerminalRule/Delete", {
            TerminalId: this.currentrow.TerminalId,
          }).then(() => {
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
    setDef() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$put("TerminalRule/SetIsDefault", {
        TerminalId: this.currentrow.TerminalId,
      }).then((r) => {
        this.$message.success("设置成功");
        this.$refs.list.getTableData();
      });
    },
  },
};
</script>

<style>
</style>